(function () {
  'use strict';

  var GROUP_ATTR = 'data-live-activation-group';
  var PLAYER_ATTR = 'data-live-activation-player';
  var INIT_ATTR = 'data-live-activation-controls-initialized';
  var idCounter = 0;

  function closestPlayer(node) {
    return node && node.closest ? node.closest('[' + PLAYER_ATTR + ']') : null;
  }

  function getPlayers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    return Array.prototype.slice.call(scope.querySelectorAll('[' + PLAYER_ATTR + ']'));
  }

  function getGroupPeers(player) {
    var group = player.getAttribute(GROUP_ATTR) || '';
    if (!group) return [];
    return getPlayers(document).filter(function (peer) {
      return peer !== player && peer.getAttribute(GROUP_ATTR) === group;
    });
  }

  function setPlayingState(player, button, playing) {
    player.classList.toggle('is-playing', playing);
    var playLabel = button.getAttribute('data-play-label') || 'Play video';
    var pauseLabel = button.getAttribute('data-pause-label') || 'Pause video';
    button.setAttribute('aria-label', playing ? pauseLabel : playLabel);
  }

  function pausePeer(peer) {
    var peerVideo = peer.querySelector('video');
    if (!peerVideo) return;
    try {
      if (!peerVideo.paused) peerVideo.pause();
    } catch (error) {}
  }

  function enhancePlayer(player) {
    if (!player || player.getAttribute(INIT_ATTR) === 'true') return;

    var video = player.querySelector('video');
    var button = player.querySelector('[data-live-activation-control]');
    if (!video || !button) return;

    player.setAttribute(INIT_ATTR, 'true');

    var preferredId = player.getAttribute('data-live-activation-video-id');
    if (preferredId) {
      video.id = preferredId;
    } else if (!video.id) {
      idCounter += 1;
      video.id = 'live-activation-video-' + idCounter;
    }
    button.setAttribute('aria-controls', video.id);

    var playLabel = button.getAttribute('aria-label') || 'Play video';
    var pauseLabel = playLabel.replace(/^Play\b/i, 'Pause');
    button.setAttribute('data-play-label', playLabel);
    button.setAttribute('data-pause-label', pauseLabel);

    function showNativeFallback() {
      player.classList.remove('is-enhanced', 'is-playing');
      button.hidden = true;
      try {
        video.controls = true;
        video.setAttribute('controls', '');
      } catch (error) {}
    }

    function commitEnhanced() {
      player.classList.add('is-enhanced');
      button.hidden = false;
      try {
        video.controls = false;
        video.removeAttribute('controls');
      } catch (error) {}
      setPlayingState(player, button, !video.paused && !video.ended);
    }

    function ensureCustomControls() {
      if (!player.classList.contains('is-enhanced')) return;
      if (video.controls || video.hasAttribute('controls')) {
        try {
          video.controls = false;
          video.removeAttribute('controls');
        } catch (error) {}
      }
    }

    function playFromUser() {
      getGroupPeers(player).forEach(pausePeer);
      ensureCustomControls();
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          showNativeFallback();
        });
      }
    }

    function pauseFromUser() {
      try {
        video.pause();
      } catch (error) {}
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (video.paused || video.ended) {
        playFromUser();
      } else {
        pauseFromUser();
      }
    });

    video.addEventListener('click', function () {
      if (!player.classList.contains('is-enhanced')) return;
      if (video.paused || video.ended) return;
      pauseFromUser();
    });

    video.addEventListener('play', function () {
      if (!player.classList.contains('is-enhanced')) return;
      ensureCustomControls();
      getGroupPeers(player).forEach(pausePeer);
      setPlayingState(player, button, true);
    });

    video.addEventListener('pause', function () {
      if (!player.classList.contains('is-enhanced')) return;
      setPlayingState(player, button, false);
    });

    video.addEventListener('ended', function () {
      if (!player.classList.contains('is-enhanced')) return;
      setPlayingState(player, button, false);
    });

    video.addEventListener('error', function () {
      showNativeFallback();
    });

    try {
      commitEnhanced();
      // story.js may reassert native controls after its deferred enhance pass
      window.requestAnimationFrame(ensureCustomControls);
      window.setTimeout(ensureCustomControls, 0);
      window.setTimeout(ensureCustomControls, 250);
    } catch (error) {
      showNativeFallback();
    }
  }

  function init(root) {
    getPlayers(root).forEach(enhancePlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target ? event.target : document);
  });
})();
